import React, { useContext, useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import BreadCrumb from "../Header/SecondHeader";
import trans from "../../utils";
import { popupcontext } from "../../context/Popupscontext";
import InspectionRequestHead from "./InspectionRequestParts/InspectionRequestHead";
import {
  useGetAllIRsQuery,
  useExportIRListToExcelMutation,
  useExportIRListToPdfMutation,
} from "../../Redux/service/IR/IR";
import Actions from "../antd/Table/Actions";
import { Tag } from "antd";
import { formatDateString } from "../../JsHelpers/DateFormat";
import Loader from "../Helpers/Loader/Loader";
import AntdTable from "../antd/Table/Table";
import { filtrationcontext } from "../../context/Filtercontext";
import InspectionRequestForm from "./InspectionRequestForm/InspectionRequestForm";
import { useSelector } from "react-redux";
import SnagLocationSelectorModal from "../snagLocation/SnagLocationSelectorModal";
import Button from "../Helpers/Button/Button";
import { FileExcelOutlined, FilePdfOutlined } from "@ant-design/icons";
import { toast } from "react-toastify";
import useIsMobile from "../../hooks/useIsMobile";
import IrMobile from "./mobile/irMobile";
import IRCopilotDrawer from "../IRCopilot/IRCopilotDrawer";
import { RobotOutlined } from "@ant-design/icons";
export default function InspectionRequest() {
  const isMobile = useIsMobile();
  const {
    handleShow,
    setEdited,
    deleteItem,
    setDeleteItem,
    setReloadData,
    reloadData,
  } = useContext(popupcontext);
  const {
    limit,
    setLimit,
    setSort: SetSortFilter,
    searchQuery,
    setSearchQuery,
  } = useContext(filtrationcontext);
  const [currentPage, setCurrentPage] = useState(1);
  const [sort, setSort] = useState({
    by: "",
    order: "",
  });
  const user = useSelector((state) => state.users.user);
  const userRole = user?.attributes?.role;

  const [filter, setFilter] = useState({
    status: null,
  });
const [copilotOpen, setCopilotOpen] = useState(false);
  // ✅ Location selection state
  const [locationModalOpen, setLocationModalOpen] = useState(false);
  const [preselectedLocation, setPreselectedLocation] = useState(null);
  const {
    data: IRData,
    isLoading,
    refetch,
  } = useGetAllIRsQuery(
    {
      page: currentPage,
      limit: limit,
      search: searchQuery,
      sortby: sort.by,
      sortorder: sort.order,
      status: filter.status,
    },
    {
      skip: !currentPage || !limit,
    },
  );
  const [exportToExcel, { isLoading: isExportingExcel }] =
    useExportIRListToExcelMutation();
  const [exportToPdf, { isLoading: isExportingPdf }] =
    useExportIRListToPdfMutation();

  const statusColors = {
    CLOSED: `blue`,
    PENDING_QA: `orange`,
    PENDING_CONSULTANT: `orange`,
    PENDING_REVIEW: `orange`,
    QA_APPROVED: `green`,
    APPROVED: `green`,
    CONSULTANT_APPROVED: `green`,
    QA_REJECTED: `red`,
    CONSULTANT_REJECTED: `red`,
    REJECTED: `red`,
    CONSULTANT_APPROVED_WITH_COMMENTS: `purple`,
    APPROVED_WITH_COMMENTS: `purple`,
    DRAFT: `default`,
    CANCELLED: `default`,
  };
  const IRColumns = [
    {
      title: trans("IR Number"),
      dataIndex: "ir_number",
      fixed: "left",
      key: "ir_number",
      width: 200,
      render: (ir_number) => <span>{ir_number}</span>,
    },
    {
      title: trans("Project"),
      key: "project",
      dataIndex: "project",
      width: 150,
      render: (_, record) => (
        <span>{record?.project?.name ? record?.project?.name : "- - - -"}</span>
      ),
    },
    {
      title: trans("Discipline"),
      key: "discipline",
      dataIndex: "discipline",
      width: 150,
      render: (discipline) => <span>{trans(discipline)}</span>,
    },
    {
      title: trans("Zone"),
      key: "zone",
      dataIndex: "zone",
      width: 150,
      render: (_, record) => (
        <span>{record?.zone?.name ? record?.zone?.name : "- - - -"}</span>
      ),
    },
    {
      title: trans("Level"),
      key: "level",
      dataIndex: "level",
      width: 150,
      render: (_, record) => (
        <span>{record?.level?.name ? record?.level?.name : "- - - -"}</span>
      ),
    },
    // ✅ ADD THIS - Room column
    {
      title: trans("Room"),
      key: "room",
      dataIndex: "room",
      width: 150,
      render: (_, record) => (
        <span>{record?.room?.name ? record?.room?.name : "- - - -"}</span>
      ),
    },
    {
      title: trans("Status"),
      key: "status",
      dataIndex: "status",
      width: 150,
      render: (_, record) => {
        // Determine status value
        const statusValue =
          record?.status_info?.value ||
          record?.status ||
          record?.original_status;

        // Determine status label
        const statusLabel =
          record?.status_info?.label ||
          record?.status ||
          record?.original_status;

        return (
          <Tag color={statusColors[statusValue] || "default"}>
            {trans(statusLabel)}
          </Tag>
        );
      },
    },
    {
      title: trans("Ready Date"),
      key: "ready_date",
      sorter: true,
      dataIndex: "ready_date",
      width: 200,
      render: (ready_date) => <span>{ready_date}</span>,
    },
    {
      title: trans("Submitted By"),
      key: "submittedBy",
      width: 180,
      render: (_, record) => <span>{record?.submittedBy?.name}</span>,
    },
    {
      title: trans("Submitted At"),
      sorter: true,
      dataIndex: "submitted_at",
      key: "submitted_at",
      width: 200,
      render: (submitted_at) => <span>{formatDateString(submitted_at)}</span>,
    },
    {
      title: trans("Actions"),
      key: "actions",
      fixed: "right",
      width: 120,
      render: (_, record) => {
        // Determine status value for IR
        const statusValue =
          record?.status_info?.value ||
          record?.status ||
          record?.original_status;
        return (
          <Actions irId={record.id} name={record.name} irStatus={statusValue} />
        );
      },
    },
  ];
  useEffect(() => {
    localStorage.setItem("page", currentPage);
  }, [currentPage]);
  useEffect(() => {
    if (reloadData) {
      refetch();
    }
    setReloadData(false);
  }, [reloadData]);
  useEffect(() => {
    return () => {
      SetSortFilter({ type: "", value: "" });
      setSearchQuery("");
    };
  }, [SetSortFilter, setSearchQuery]);
  const handleTableChange = (pagination, filters, sorter) => {
    if (sorter.order) {
      setSort({
        by: sorter.field,
        order: sorter.order === "ascend" ? "asc" : "desc",
      });
    } else {
      setSort({
        by: "",
        order: "",
      });
    }
  };
  useEffect(() => {
    setCurrentPage(1);
  }, [searchQuery]);

  // ✅ Clear preselectedLocation when form closes
  const { form } = useContext(popupcontext);
  useEffect(() => {
    if (!form && preselectedLocation) {
      setPreselectedLocation(null);
    }
  }, [form, preselectedLocation]);

  const handleExportToExcel = async () => {
    try {
      await exportToExcel({
        search: searchQuery,
        status: filter.status,
        sortby: sort.by,
        order: sort.order,
      }).unwrap();
      toast.success(trans("Excel file downloaded successfully"), {
        autoClose: 2000,
        rtl: localStorage.getItem("lang") === "ar",
      });
    } catch (error) {
      console.error("Export to Excel failed:", error);
      toast.error(trans("Failed to export to Excel"), {
        autoClose: 2000,
        rtl: localStorage.getItem("lang") === "ar",
      });
    }
  };

  const handleExportToPdf = async () => {
    try {
      await exportToPdf({
        search: searchQuery,
        status: filter.status,
        sortby: sort.by,
        order: sort.order,
      }).unwrap();
      toast.success(trans("PDF file downloaded successfully"), {
        autoClose: 2000,
        rtl: localStorage.getItem("lang") === "ar",
      });
    } catch (error) {
      console.error("Export to PDF failed:", error);
      toast.error(trans("Failed to export to PDF"), {
        autoClose: 2000,
        rtl: localStorage.getItem("lang") === "ar",
      });
    }
  };

  return (
    <>
      <Helmet>
        <title>Inspection Request</title>
        <meta name="description" content="IR" />
      </Helmet>
      {isMobile ? (
        <IrMobile userRole={userRole} />
      ) : (
        <>
<BreadCrumb
  title={trans("Inspection Request")}
  add={userRole === "contractor" ? trans("Add new IR") : undefined}
  onClick={() => setLocationModalOpen(true)}
  // === NEW: secondary "Create with AI" button ===
  secButton={
    userRole === "contractor" ? trans("Create with AI") : undefined
  }
  secClick={() => setCopilotOpen(true)}
/>
          <div style={{ position: "relative" }}>
            <InspectionRequestHead setFilter={setFilter} />
            <div
              style={{
                position: "absolute",
                top: "50%",
                right: 0,
                transform: "translateY(-50%)",
                display: "flex",
                alignItems: "center",
                gap: "12px",
                paddingRight: "16px",
              }}
            >
              {/* ✅ Export Buttons */}
              <Button
                type="default"
                icon={<FileExcelOutlined />}
                onClick={handleExportToExcel}
                loading={isExportingExcel}
                disabled={isExportingExcel || isExportingPdf}
                title={trans("Export to Excel")}
              >
                {trans("Excel")}
              </Button>

              <Button
                type="default"
                icon={<FilePdfOutlined />}
                onClick={handleExportToPdf}
                loading={isExportingPdf}
                disabled={isExportingExcel || isExportingPdf}
                title={trans("Export to PDF")}
              >
                {trans("PDF")}
              </Button>
            </div>
          </div>
          {isLoading ? (
            <>
              <div className="loader-container loader-table">
                <Loader />
              </div>
            </>
          ) : (
            <>
              <div className="bg-white-rounded-top table-parent mt-4">
                <AntdTable
                  columns={IRColumns}
                  dataSource={IRData?.data || []}
                  loading={isLoading}
                  pageSize={limit}
                  totalItems={IRData?.pagination?.total || 0}
                  currentPage={currentPage}
                  onPageChange={(page) => setCurrentPage(page)}
                  onLimitChange={(newLimit) => {
                    setLimit(newLimit);
                    setCurrentPage(1);
                  }}
                  onTableChange={handleTableChange}
                />
              </div>
            </>
          )}
          <SnagLocationSelectorModal
            open={locationModalOpen}
            onClose={() => {
              setLocationModalOpen(false);
            }}
            onConfirm={(locationData) => {
              console.log("Location data confirmed:", locationData);
              setPreselectedLocation(locationData);
              setLocationModalOpen(false);
              handleShow("addForm");
            }}
          />
          <InspectionRequestForm preselectedLocation={preselectedLocation} />
          <IRCopilotDrawer
  open={copilotOpen}
  onClose={() => setCopilotOpen(false)}
  onSubmitted={() => {
    setReloadData(true);
    setCopilotOpen(false);
  }}
/>
        </>
      )}
    </>
  );
}
